<template>
  <div class="modal__wrap--bg cmp-modal" :class="{'is-active' : previewModal}" id="preview-modal-template" v-if="previewModal">
    <div class="modal-wrap-container modal-wd1020">
      <div class="modal-header">
        <div class="title">이력서 미리보기</div>
      </div>
      <div class="modal-body-container ht-full">
        <h3 class="section-title mt-40">{{ basic.indnm }} <span>{{  genderLabel }} | {{ basic.birthdyYear }}년({{ getAge }}세)</span></h3>
        <div class="table-wrap border-top-none mt-0">
          <table class="table-body-only">
            <caption>기본정보 테이블</caption>
            <colgroup class="pc-cell">
              <col style="width: 160px;" />
              <col />
            </colgroup>
            <colgroup class="mo-cell">
              <col style="width: 88px;" />
              <col />
            </colgroup>
            <tbody>
              <tr>
                <th scope="row">휴대<br class="mo-only">전화번호</th>
                <td>{{ basic.hp1 }}-{{ basic.hp2 }}-{{ basic.hp3 }}</td>
              </tr>
              <tr>
                <th scope="row">이메일</th>
                <td>{{ basic.email }}</td>
              </tr>
              <tr>
                <th scope="row">비상<br class="mo-only">연락처</th>
                <td>{{ basic.tel1 }}-{{ basic.tel2 }}-{{ basic.tel3 }}</td>
              </tr>
              <tr>
                <th scope="row">주소</th>
                <td>{{ basic.addr }}<br>{{ basic.addrDtl }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <h3 class="section-title mt-40">학력사항 기본정보</h3>
        <div class="table-wrap border-top-none mt-0">
          <table class="table-body-only">
            <caption>학력사항 정보 테이블</caption>
            <colgroup class="pc-cell">
              <col style="width: 160px;" />
              <col />
            </colgroup>
            <colgroup class="mo-cell">
              <col style="width: 88px;" />
              <col />
            </colgroup>
            <tbody>
              <tr>
                <th scope="row">최종학력</th>
                <td>{{ lastDulvName }}</td>
              </tr>
              <tr>
                <th scope="row">
                  최종학력<br>졸업여부
                </th>
                <td>{{ lastEduLvStat }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <h3 class="section-title mt-40">학교 및 전공 정보</h3>
        <div class="table-wrap border-top-none mt-0" v-for="(school, index) in schools" :key="index">
          <table class="table-body-only">
            <caption>학교 및 전공 정보 테이블</caption>
            <colgroup class="pc-cell">
              <col style="width: 160px;" />
              <col />
            </colgroup>
            <colgroup class="mo-cell">
              <col style="width: 88px;" />
              <col />
            </colgroup>
            <tbody>
              <tr>
                <th scope="row">학교명</th>
                <td>{{ school.displaySchoolName }}</td>
              </tr>
              <tr>
                <th scope="row">학력구분</th>
                <td>{{ school.schoolTypeName }}</td>
              </tr>
              <tr>
                <th scope="row">전공</th>
                <td>{{ school.displayMajor }}</td>
              </tr>
              <tr>
                <th scope="row">부전공</th>
                <td>{{ school.subMajor }}</td>
              </tr>
              <tr>
                <th scope="row">졸업여부</th>
                <td>{{ school.graduationStatusName }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <h3 class="section-title mt-40">경력사항</h3>
        <div class="table-wrap border-top-none mt-0" v-for="(career, index) in careers" :key="index">
          <table class="table-body-only">
            <caption>경력사항 테이블</caption>
            <colgroup class="pc-cell">
              <col style="width: 160px;" />
              <col />
            </colgroup>
            <colgroup class="mo-cell">
              <col style="width: 88px;" />
              <col />
            </colgroup>
            <tbody>
              <tr>
                <th scope="row">회사<br class="mo-only">(단체)명</th>
                <td>{{ career.compnm }}</td>
              </tr>
              <tr>
                <th scope="row">근무<br class="mo-only">(활동)기간</th>
                <td>{{ career.carrStde }}~{{ career.carrEdde }}</td>
              </tr>
              <tr>
                <th scope="row">직위</th>
                <td>{{ career.pos }}</td>
              </tr>
              <tr>
                <th scope="row">담당업무</th>
                <td>{{ career.resbiz }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <h3 class="section-title mt-40">보유 자격증/면허증</h3>
        <div class="table-wrap border-top-none mt-0" v-for="(qualification, index) in qualifications" :key="index">
          <table class="table-body-only">
            <caption>보유 자격증/면허증 테이블</caption>
            <colgroup class="pc-cell">
              <col style="width: 160px;" />
              <col />
            </colgroup>
            <colgroup class="mo-cell">
              <col style="width: 88px;" />
              <col />
            </colgroup>
            <tbody>
              <tr>
                <th scope="row">자격증/<br class="mo-only">면허증</th>
                <td>{{ qualification.quanm }}</td>
              </tr>
              <tr>
                <th scope="row">발행처/<br class="mo-only">발행기관</th>
                <td>{{ qualification.publicOrg }}</td>
              </tr>
              <tr>
                <th scope="row">합격구분</th>
                <td>{{ getPassNm(qualification.passcd) }}</td>
              </tr>
              <tr>
                <th scope="row">취득년도</th>
                <td>{{ qualification.getdate }}년</td>
              </tr>
            </tbody>
          </table>
        </div>

        <h3 class="section-title mt-40">OA작성능력</h3>
        <div class="table-wrap border-top-none mt-0" v-for="(oaskill, index) in oaskills" :key="index">
          <table class="table-body-only">
            <caption>OA작성능력 테이블</caption>
            <colgroup class="pc-cell">
              <col style="width: 160px;" />
              <col />
            </colgroup>
            <colgroup class="mo-cell">
              <col style="width: 88px;" />
              <col />
            </colgroup>
            <tbody>
              <tr>
                <th scope="row">문서작성<br>(한글/MS-Word)</th>
                <td>{{ getSkillsNm(oaskill.docSkl) }}</td>
              </tr>
              <tr>
                <th scope="row">스프레드시트<br>(Excel)</th>
                <td>{{ getSkillsNm(oaskill.shetSkl) }}</td>
              </tr>
              <tr>
                <th scope="row">프리젠테이션<br>(PowerPoint)</th>
                <td>{{ getSkillsNm(oaskill.pptSkl) }}</td>
              </tr>
              <tr>
                <th scope="row">인터넷<br>(정보검색/outlook)</th>
                <td>{{ getSkillsNm(oaskill.interSkl) }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <h3 class="section-title mt-40">주요활동/사회공헌</h3>
        <div class="table-wrap border-top-none mt-0" v-for="activity in activities" :key="activity.seq">
          <table class="table-body-only">
            <caption>주요활동/사회공헌 테이블 </caption>
            <colgroup class="pc-cell">
              <col style="width: 160px;" />
              <col />
            </colgroup>
            <colgroup class="mo-cell">
              <col style="width: 88px;" />
              <col />
            </colgroup>
            <tbody>
              <tr>
                <th scope="row">활동구분</th>
                <td>{{ getActNm(activity.actCd) }}</td>
              </tr>
              <tr>
                <th scope="row">활동기간</th>
                <td>{{ activity.actperSt }} - {{ activity.actperEd }}</td>
              </tr>
              <tr>
                <th scope="row">기관/장소</th>
                <td>{{ activity.compnm }}</td>
              </tr>
              <tr>
                <th scope="row">활동내용</th>
                <td>{{ activity.actDesc }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <h3 class="section-title mt-40">희망 활동(근무) 조건</h3>
        <div class="table-wrap border-top-none mt-0">
          <table class="table-body-only">
            <caption>희망 활동(근무) 조건 테이블</caption>
            <colgroup class="pc-cell">
              <col style="width: 160px;" />
              <col />
            </colgroup>
            <colgroup class="mo-cell">
              <col style="width: 88px;" />
              <col />
            </colgroup>
            <tbody>
              <tr>
                <th scope="row">업직종</th>
                <td>{{ getOccupationNm(preferences.desiredOccupationCd) }}</td>
              </tr>
              <tr>
                <th scope="row">희망시급</th>
                <td>{{ getSalaryNm(preferences.desiredSalaryRange) }}</td>
              </tr>
              <tr>
                <th scope="row">고용형태</th>
                <td>{{ getEmploymentTypeNm(preferences.desiredEmploymentTypeCd) }}</td>
              </tr>
              <tr>
                <th scope="row">희망근무지역</th>
                <td>{{ getWorkRegionNm(preferences.desiredWorkRegion) }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <h3 class="section-title mt-40">자기소개서</h3>
        <div class="table-wrap border-top-none mt-0">
          <table class="table-body-only">
            <caption>자기소개서 테이블</caption>
            <colgroup class="pc-cell">
              <col />
            </colgroup>
            <tbody>
              <tr>
                <th scope="col" class="sr-only">
                  내용
                </th>
              </tr>
              <tr>
                <td>
                  <div class="text-box-section resume-area" style="white-space: pre-line; word-break: break-all;" v-text="introduction.selfintro">
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <h3 class="section-title mt-40">사업 참여이력</h3>
        <div class="table-wrap border-top-none mt-0" v-for="(jobActHistory, index) in jobActHistories" :key="index">
          <table class="table-body-only">
            <caption>사업 참여이력 테이블</caption>
            <colgroup class="pc-cell">
              <col style="width: 160px;" />
              <col />
            </colgroup>
            <colgroup class="mo-cell">
              <col style="width: 88px;" />
              <col />
            </colgroup>
            <tbody>
              <tr>
                <th scope="row" colspan="2">
                  <div class="history-item">
                    <div class="history-item-num">01</div>
                    <div class="history-item-subject">
                      {{ jobActHistory.bizCateName }} ({{ jobActHistory.bizYear }})
                    </div>
                  </div>
                </th>
              </tr>
              <tr>
                <th scope="row" class="no-bg">세부<br class="mo-only">사업명</th>
                <td>{{ jobActHistory.detailBizName }}</td>
              </tr>
              <tr>
                <th scope="row" class="no-bg">공고명</th>
                <td>{{ jobActHistory.annName }}</td>
              </tr>
              <tr>
                <th scope="row" class="no-bg">활동기간</th>
                <td>{{ jobActHistory.actStartDate }} ~ {{ jobActHistory.actEndDate }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <h3 class="section-title mt-40">교육 이수이력</h3>
        <div class="table-wrap border-top-none mt-0" v-for="(educationHistory, index) in educationHistories" :key="index">
          <table class="table-body-only">
            <caption>교육 이수이력 테이블</caption>
            <colgroup class="pc-cell">
              <col style="width: 160px;" />
              <col />
            </colgroup>
            <colgroup class="mo-cell">
              <col style="width: 88px;" />
              <col />
            </colgroup>
            <tbody>
              <tr>
                <th scope="row" colspan="2">
                  <div class="history-item">
                    <div class="history-item-num">{{ index }}</div>
                    <div class="history-item-subject">
                      {{ educationHistory.lectureName }}
                    </div>
                  </div>
                </th>
              </tr>
              <tr>
                <th scope="row" class="no-bg">기관</th>
                <td>{{ educationHistory.orgName }}</td>
              </tr>
              <tr>
                <th scope="row" class="no-bg">
                  사업년도<br>(중분류)
                </th>
                <td>{{ educationHistory.termName }}</td>
              </tr>
              <tr>
                <th scope="row" class="no-bg">
                  소분류<br>(이수여부)
                </th>
                <td>{{ educationHistory.facultyName }}</td>
              </tr>
              <tr>
                <th scope="row" class="no-bg">
                  교육기간
                </th>
                <td>{{ educationHistory.educationPeriod }}</td>
              </tr>
              <tr>
                <th scope="row" class="no-bg">
                  강사
                </th>
                <td>{{ educationHistory.instructorName }}</td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-md button-wid150" @click="close">
          닫기
        </button>
        <button type="button" class="btn btn-primary btn-md button-wid150" @click="modify">
          <i class="ico ico-pen-wt"></i>
          수정하기
        </button>
      </div>
      <button type="button" class="btn btn-close only-icon close-modal" aria-label="닫기" @click="close" title="닫기">
        <i class="ico ico-x-bl"></i>
      </button>
    </div>
  </div>
</template>

<script>
import Axios from 'axios';

const gender = {
  M: '남',
  F: '여',
};

export default {
  name: 'preview-modal-template',
  props: ['previewModal', 'indbankNo'],
  data() {
    return {
      basic: {},
      schools: [],
      careers: [],
      qualifications: [],
      oaskills: {},
      activities: {},
      preferences: {},
      introduction: {},
      jobActHistories: [],
      educationHistories: [],
      codes: {},
    };
  },
  watch: {
    previewModal: {
      handler(newVal) {
        if (newVal) {
          this.getBasic();
          this.getSchools();
          this.getCareers();
          this.getQualifications();
          this.getOaskills();
          this.getActivities();
          this.getPreferences();
          this.getIntroduction();
          this.getJobActHistories();
          this.getEducationHistories();
        }
      },
      immediate: true,
    },
  },
  methods: {
    close() {
      $('body').removeClass('modal-open');
      this.$emit('closePreviewModal');
    },
    getBasic() {
      Axios.get(`/api/idb/${this.indbankNo}/basic`).then((response) => {
        if (response.data.success === 'R') {
          this.basic = response.data.data;
        }
      }).catch((e) => {
        alert(e.response.data.message);
      });
    },
    getSchools() {
      Axios.get(`/api/idb/${this.indbankNo}/schools`).then((response) => {
        if (response.data.success === 'R') {
          this.schools = response.data.data;
          if (response.data.data.length === 0) this.schools.push('');
        }
      }).catch((e) => {
        alert(e.response.data.message);
      });
    },
    getCareers() {
      Axios.get(`/api/idb/${this.indbankNo}/careers`).then((response) => {
        if (response.data.success === 'R') {
          this.careers = response.data.data;
          if (response.data.data.length === 0) this.careers.push('');
        }
      }).catch((e) => {
        alert(e.response.data.message);
      });
    },
    getQualifications() {
      Axios.get(`/api/idb/${this.indbankNo}/qualifications`).then((response) => {
        if (response.data.success === 'R') {
          this.qualifications = response.data.data;
          if (response.data.data.length === 0) this.qualifications.push('');
        }
      }).catch((e) => {
        alert(e.response.data.message);
      });
    },
    getOaskills() {
      Axios.get(`/api/idb/${this.indbankNo}/oaskills`).then((response) => {
        if (response.data.success === 'R') {
          this.oaskills = response.data.data;
          if (response.data.data.length === 0) this.oaskills.push('');
        }
      }).catch((e) => {
        alert(e.response.data.message);
      });
    },
    getActivities() {
      Axios.get(`/api/idb/${this.indbankNo}/activities`).then((response) => {
        if (response.data.success === 'R') {
          this.activities = response.data.data;
          if (response.data.data.length === 0) this.activities.push('');
        }
      }).catch((e) => {
        alert(e.response.data.message);
      });
    },
    getPreferences() {
      Axios.get(`/api/idb/${this.indbankNo}/preferences`).then((response) => {
        if (response.data.success === 'R') {
          this.preferences = response.data.data;
        }
      }).catch((e) => {
        alert(e.response.data.message);
      });
    },
    getIntroduction() {
      Axios.get(`/api/idb/${this.indbankNo}/introduction`).then((response) => {
        if (response.data.success === 'R') {
          this.introduction = response.data.data;
        }
      }).catch((e) => {
        alert(e.response.data.message);
      });
    },
    getJobActHistories() {
      Axios.get('/api/idb/job-act-history').then((response) => {
        if (response.data.success === 'R') {
          this.jobActHistories = response.data.data;
          if (response.data.data.length === 0) this.jobActHistories.push('');
        }
      }).catch((e) => {
        alert(e.response.data.message);
      });
    },
    getEducationHistories() {
      Axios.get('/api/idb/education-history').then((response) => {
        if (response.data.success === 'R') {
          this.educationHistories = response.data.data;
          if (response.data.data.length === 0) this.educationHistories.push('');
        }
      }).catch((e) => {
        alert(e.response.data.message);
      });
    },
    getResumeCodes() {
      Axios.get('/api/common-codes/resume-codes').then((response) => {
        this.codes = response.data;
      }).catch((e) => {
        alert(e.response.data.message);
      });
    },
    getLevelNm(code) {
      let name = '';
      this.codes.educationLevels.forEach((item) => {
        if (item.code === code) name = item.name;
      });
      return name;
    },
    getSkillsNm(code) {
      let name = '';
      this.codes.oaSkills.forEach((item) => {
        if (item.code === code) name = item.name;
      });
      return name;
    },
    getPassNm(code) {
      let name = '';
      this.codes.passingSteps.forEach((item) => {
        if (item.code === code) name = item.name;
      });
      return name;
    },
    getSalaryNm(code) {
      let name = '';
      this.codes.desiredSalaryRanges.forEach((item) => {
        if (item.code === code) name = item.name;
      });
      return name;
    },
    getEmploymentTypeNm(code) {
      let name = '';
      this.codes.desiredEmploymentTypeCodes.forEach((item) => {
        if (item.code === code) name = item.name;
      });
      return name;
    },
    getWorkRegionNm(codes) {
      if (!this.codes.desiredWorkRegions || !codes || typeof codes !== 'string') return '';
      const name = [];
      codes.split(',').forEach((code) => {
        this.codes.desiredWorkRegions.forEach((item) => {
          if (item.code === code) name.push(item.name);
        });
      });
      return (name.length > 0) ? name.join(',') : '';
    },
    getActNm(code) {
      let name = '';
      this.codes.activities.forEach((item) => {
        if (item.code === code) name = item.name;
      });
      return name;
    },
    getOccupationNm(code) {
      let name = '';
      this.codes.desiredOccupationCodes.forEach((item) => {
        if (item.code === code) name = item.name;
      });
      return name;
    },
    modify() {
      this.close();
      this.$emit('openDetail', this.indbankNo);
    },
  },
  computed: {
    genderLabel() {
      return gender[this.basic.gender];
    },
    getAge() {
      const today = new Date();

      // 숫자 타입 확인
      if (!this.basic.birthdyYear || !this.basic.birthdyMonth || !this.basic.birthdyDay) {
        return 0;
      }

      let age = today.getFullYear() - this.basic.birthdyYear;
      const monthDifference = today.getMonth() + 1 - this.basic.birthdyMonth; // getMonth()는 0부터 시작
      if (monthDifference < 0
        || (monthDifference === 0 && today.getDate() < this.basic.birthdyDay)) {
        age -= 1;
      }
      return age;
    },
    lastDulvName() {
      let name = '';
      this.codes.educationLevels.forEach((item) => {
        if (item.code === this.basic.lastEdulv) name = item.name;
      });
      return name;
    },
    lastEduLvStat() {
      let name = '';
      this.codes.graduationStatuses.forEach((item) => {
        if (item.code === this.basic.lastEdulvStat) name = item.name;
      });
      return name;
    },
  },
  mounted() {
    this.getResumeCodes();
  },
};
</script>



// WEBPACK FOOTER //
// Preview.vue?4906666b